



































































































































































































































import { Component, Vue, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { timeFormat } from "@/utils";
import { constantRouterMap } from "@/router";

@Component({
  name: "systemLog",
})
export default class PerformanceManagement extends Vue {
  @Provide() private id: string = "";
  @Provide() private thirdparty: string = ""; // 三方名称
  @Provide() private thirdpartyLists: any = []; // 三方名称列表
  @Provide() private relatedTid: string = ""; //关联业务id
  @Provide() private relatedUid: string = ""; //关联业务用户ID，
  @Provide() private apiType: string = ""; //功能分类
  @Provide() private api: string = ""; //API URL
  @Provide() private apiTag: string = ""; //ApiTag
  @Provide() private apiTagList: any = []; // 功能分类列表

  @Provide() private request: string = ""; //请求体
  @Provide() private response: string = ""; //响应体
  @Provide() private httpResponseCode: string = ""; //响应Code
  @Provide() private consumingStart: string = ""; //耗时开始
  @Provide() private consumingEnd: string = ""; //耗时结束
  @Provide() private requestAppKey: string = ""; //三方的账号
  @Provide() private fromAppKey: string = ""; // 目前没用
  @Provide() private isFailure: string = ""; //是否是服务故障
  @Provide() private isFailureOptions: any = [
    {
      value: 1,
      name: "v0707.Yes",
    },
    {
      value: 2,
      name: "v0707.No",
    },
  ]; // 是否是服务故障选项
  @Provide() private isBilling: string = ""; //是否收费
  @Provide() private isBillingOptions: any = [
    {
      value: 1,
      name: "v0707.Yes",
    },
    {
      value: 2,
      name: "v0707.No",
    },
  ]; //是否收费选项
  @Provide() private dates: any = []; //操作时间
  @Provide() private beginDate: string = ""; //开始时间
  @Provide() private endDate: string = ""; //结束时间
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() private pagnition: any = pagnition;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private resultData: any = [];

  private created() {
    this.getThirdpartyLogParams();
    this.getLogList();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.searchFormAction();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.searchFormAction();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.searchFormAction();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.searchFormAction();
  }
  private consumingStartChange(e: any) {
    this.consumingStart = e.target.value;
  }
  private consumingEndChange(e: any) {
    this.consumingEnd = e.target.value;
  }

  // lee 获取列表
  private async getLogList() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.searchFormAction();
  }
  private async searchFormAction() {
    let _arg: any = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      id: this.id,
      thirdparty: this.thirdparty, // 三方名称
      relatedTid: this.relatedTid, //关联业务id
      relatedUid: this.relatedUid, //关联业务用户ID，
      apiType: this.apiType, //功能分类
      api: this.api, //API URL
      apiTag: this.apiTag, //ApiTag
      request: this.request, //请求体
      response: this.response, //响应体
      httpResponseCode: +this.httpResponseCode, //响应Code
      consumingStart: +this.consumingStart, //耗时开始
      consumingEnd: +this.consumingEnd, //耗时结束
      requestAppKey: this.requestAppKey, //三方的账号
      fromAppKey: this.fromAppKey, // 目前没用
      isFailure: +this.isFailure, //是否是服务故障
      isBilling: +this.isBilling, //是否收费
    };
    if (this.dates && this.dates.length > 0) {
      _arg.beginDate = timeFormat(this.dates[0].getTime());
      _arg.endDate = timeFormat(this.dates[1].getTime());
    }
    this.isSearchFormActionDone = true;
    const { getListThirdpartyLogReq, getListThirdpartyLogRequest }: any = await import(
      "@/request/logging"
    );
    let res = await getListThirdpartyLogRequest.handleHttp(
      getListThirdpartyLogReq(_arg),
      this
    );
    this.isSearchFormActionDone = res ? res.loading : false;
    if (res && res.right) {
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
      if (res.thirdpartysList) {
        this.resultData = res.thirdpartysList.map((item: any) => {
          let isfailurename = "";
          let isbillingname = "";
          isfailurename = item.isfailure == 1 ? "是" : "否";
          isbillingname = item.isbilling == 1 ? "是" : "否";
          item.ctime = timeFormat(Number(item.ctime));
          this.$set(item, "isbillingname", isbillingname);
          this.$set(item, "isfailurename", isfailurename);
          return item;
        });
      }
    } else {
      this.isSearchFormActionDone = false;
    }
  }
  // 获取ThirdpartyLogParams
  private async getThirdpartyLogParams() {
    const {
      getListThirdpartyLogParamsReq,
      getListThirdpartyLogParamsRequest,
    }: any = await import("@/request/logging");
    let res = await getListThirdpartyLogParamsRequest.handleHttp(
      getListThirdpartyLogParamsReq(),
      this
    );
    if (res && res.right) {
      let data = JSON.parse(res.params);
      this.thirdpartyLists = data.thridparty;
      this.apiTagList = data.apitag;
    }
  }
}
